import React from "react";
import CourbesStatChart from "./CourbesStatChart.jsx";

/**
 * Besoin en eau cumulé, en ÉCART avec 2020 (ou la référence en TRACC), via
 * CourbesStatChart.
 *
 * On cumule d'abord chaque statistique du besoin en eau jour après jour (data.eau),
 * puis on fait la différence des cumuls : pour moyen, q75 et q90, la valeur de
 * 2035 est q75_cumulé_2035 - q75_cumulé_2020 (idem moyen / q90), celle de 2050
 * q75_cumulé_2050 - q75_cumulé_2020.
 *
 * Pas de tableau (mais sa place est gardée : le graphique a la même largeur que
 * les deux autres de la page, avec du blanc à droite) et pas de 2020 dans le
 * sélecteur d'années (c'est la base de l'écart). Statistiques proposées :
 * Moyen, Quantile 75 et Quantile 90 (pas de Maximum). Coché à l'ouverture :
 * Quantile 90 seulement.
 */
export default function EauCumuleeEcartChart({ data, xMax }) {
  return (
    <CourbesStatChart
      data={data}
      prefixe="besoin"
      cleDate="date_affichage"
      unite="mm"
      nomAxe="Écart de besoin en eau cumulé avec 2020 (mm)"
      statsParDefaut={["q90"]}
      statsDisponibles={["moy", "q75", "q90"]}
      cumul
      ecartAvecBase
      afficherTableau={false}
      reserverPlaceTableau
      xMax={xMax}
    />
  );
}
